// extracted by mini-css-extract-plugin
export default {"infoHead":"customMap_infoHead__zB4f7","infoContent":"customMap_infoContent__oqdku","infoText":"customMap_infoText__O++b8"};